export default {"src":"/_next/static/media/HeartDiseaseStroke.e0d91209.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};